import { render, staticRenderFns } from "./AddNewSubComment.vue?vue&type=template&id=0c4510c6&"
import script from "./AddNewSubComment.vue?vue&type=script&lang=js&"
export * from "./AddNewSubComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports